import { useQuery } from "@tanstack/react-query";
import { getJobEvents } from "../actions/getJobEvents";
import { useState, useCallback } from "react";

export interface JobEventsResponse {
  items: any[];
  page: number;
  pageSize: number;
  totalPages: number;
  totalItems: number;
  currentEventIndex: number;
}

export function useJobEventsPaginated( parentId: number, { pageSize = 10 } = {}) {
  const [page, setPage] = useState(1); //Paginacion actual

  const query = useQuery<JobEventsResponse, Error, JobEventsResponse>({
    queryKey: ["job-events", parentId, page, pageSize],
    queryFn: async () => {
      return await getJobEvents({
        jobId: parentId,
        page,
        pageSize,
      }) as JobEventsResponse;
    },
    enabled: Boolean(parentId),
    staleTime: 1000 * 30,
  });

  const items = query.data?.items ?? [];
  const currentEventIndex = query.data?.currentEventIndex


  const totalPages = query.data?.totalPages ?? 1;
  const totalItems = query.data?.totalItems ?? 0;

  const canNextPage = page < totalPages;
  const canPrevPage = page > 1;
  

  const nextPage = useCallback(() => {
    if (canNextPage) setPage((p) => p + 1);
  }, [canNextPage]);

  const prevPage = useCallback(() => {
    if (canPrevPage) setPage((p) => p - 1);
  }, [canPrevPage]);

  const resetPage = useCallback(() => setPage(1), []);

  const goToCurrentJobPage = () => {
  if (currentEventIndex == null || currentEventIndex < 0) return;

  const pageOfCurrent = Math.floor(currentEventIndex / pageSize) + 1;

  setPage(pageOfCurrent);
};

  return {
    ...query,
    events: items,
    totalItems,
    currentEventIndex,
    totalPages,
    page,
    pageSize,
    setPage,
    nextPage,
    prevPage,
    resetPage,
    canNextPage,
    canPrevPage,
    goToCurrentJobPage,
  };
}
